import { http } from '../../config/axios'

 const findMotorCreditoFormula = (params:any): Promise<any> => {
  const queryParams = params
                ? Object.keys(params)
                      .map((k) => encodeURIComponent(params[k]))
                      .join('/')
                : '';
  return http
    .get('api/motorcreditoformula/find/' + queryParams)
    .then((res) => {
      return res.data as any
    })
    .catch((error) => {
      console.error('Erro findMotorCreditoFormula', error)
      throw Error(error.response.data)
    })
}

export default findMotorCreditoFormula;
